import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ECCacvRedistributionMode} from 'smag-commons/dto/eco';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {CACV_STRING} from '../../../../shared/ec-economics';

export interface CacvYearlyValue {
    cacvMode: ECCacvRedistributionMode;
    year: number;
}


@Component({
    selector: 'app-set-cacv',
    templateUrl: './set-cacv.component.html',
    styleUrls: ['./set-cacv.component.scss']
})
export class SetCacvComponent implements OnInit, OnDestroy {
    private destroyed = new Subject<void>();

    @Input() year: number;
    @Input() currentCacvMode: ECCacvRedistributionMode;
    @Output() cacvYearlyValue: EventEmitter<CacvYearlyValue> = new EventEmitter<CacvYearlyValue>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

    form: FormGroup;
    cacvModes: ECCacvRedistributionMode[] = [
        ECCacvRedistributionMode.PLANTS,
        ECCacvRedistributionMode.REDISTRIBUTION,
        ECCacvRedistributionMode.SET_ASIDE,
        ECCacvRedistributionMode.AS_TIP
    ];

    readonly CACV_STRING = CACV_STRING;

    constructor(private fb: FormBuilder) {
        this.form = this.fb.group({
            cacvMode: new FormControl(null, [Validators.required])
        });
    }

    ngOnInit(): void {
        this.form.controls.cacvMode.setValue(this.currentCacvMode);

        this.form.controls.cacvMode.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(value => {
                this.cacvYearlyValue.next({
                    cacvMode: value,
                    year: this.year
                });
                this.valid.next(this.currentCacvMode !== value && this.form.controls.cacvMode.valid);
            });
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

}
